import type { FC } from "react";

import { isNil } from "lodash";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { NO_DATA_SIGN } from "app/filters/const";
import { translate } from "app/filters/i18nFilter";

import { SearchOverviewTexts } from "../../../../texts";
import type { SearchKeywordsData } from "../../../../types";
import ChangeIndicator from "../ChangeIndicator/ChangeIndicator";

import { Container, GreyCaptionText, PercentValue } from "./styledComponents";

interface KeywordsGraphChangeProps {
    data?: SearchKeywordsData;
    isLoading?: boolean;
}
const KeywordsGraphChange: FC<KeywordsGraphChangeProps> = ({ data, isLoading }) => {
    const numOfKeywords = !data?.numOfKeywords ? NO_DATA_SIGN : data.numOfKeywords;
    return (
        <Container>
            {isLoading ? (
                <PixelPlaceholderLoader
                    height={19}
                    width="100%"
                />
            ) : (
                <>
                    <GreyCaptionText>
                        <PercentValue>{numOfKeywords}</PercentValue>
                        <span>{translate(SearchOverviewTexts.keywords)}</span>
                    </GreyCaptionText>
                    {!isNil(data?.changeOfKeywords) ? <ChangeIndicator change={data.changeOfKeywords} /> : null}
                </>
            )}
        </Container>
    );
};

export default KeywordsGraphChange;
